import { brand } from "../config/brands";
import React, { useEffect, useState } from "react";
import Layout from "../component/Layout";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { ApiUrlService } from '../api-library/api-services';
import { ArrowUpTrayIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import { addBanner, deleteBanner, getBusiness } from "../adapter/api";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Banners.css";


const Banners = () => {

  const apiUrlService = new ApiUrlService();
  const [banners, setBanners] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [restaurants, setRestaurants] = useState([]);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [number, setNumber] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  // Fetch restaurants and products
  const fetchDropdownData = async () => {
    // Example URLs; update with actual API endpoints
    const response = await getBusiness();
    console.log(JSON.stringify(response.data.data))
    setRestaurants(response.data.data)

  };

  const handleRestaurantChange = (e) => {
    const restaurant = restaurants.find((r) => r.restaurant_id === e.target.value);
    setSelectedRestaurant(restaurant);
    setSelectedCategory(null);
    setSelectedProduct(null);
  };

  const handleCategoryChange = (e) => {
    const category = selectedRestaurant.menuCategory.find((c) => c.menuCatId === e.target.value);
    setSelectedCategory(category);
    setSelectedProduct(null);
  };

  const handleProductChange = (e) => {
    const product = selectedCategory.products.find((p) => p.productId === e.target.value);
    setSelectedProduct(product);
  };

  useEffect(() => {
    getBanners();
    fetchDropdownData();
  }, []);




  const getBanners = () => {
    var service = apiUrlService.GetApi();
    fetch(`${brand.apiBaseUrl}/bannerAdmin`, service).then(res => res.json())
      .then(
        (data) => {
          console.log(JSON.stringify(data.data))
          setBanners(data.data)
        }


      );
  }

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedImage(file);
      const formData = new FormData();
      formData.append("file", file);
      try {
        const response = await axios.post(
          `${brand.apiBaseUrl}/saveImage`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        setUploadedImage(response.data.data)
      } catch (error) {
        console.error("Error uploading image:", error.message);
        toast.error("Failed to upload image.");
      }
    }
  };

  const handleDelete = async() => {
    if (!banners.length || !banners[activeIndex]) {
      toast.error("There are no banners to delete.");
      return;
    }
    const response = await deleteBanner(banners[activeIndex].bannerId)
    if(response.status){
      toast.success("Deleted!")
      getBanners()
    }else{
      toast.error("Error!")
    }
    //setBanners((prevBanners) => prevBanners.filter((_, index) => index !== activeIndex));
  };


  const handleSave = async () => {
      if (!uploadedImage || !number) {
        toast.error("Please complete all required fields.");
        return;
      }
    
      const restaurantId = selectedRestaurant ? selectedRestaurant.restaurant_id : null;
      const categoryId = selectedCategory ? selectedCategory.menuCatId : null;
      const productId = selectedProduct ? selectedProduct.productId : null;
    
      const response = await addBanner(uploadedImage, number, restaurantId, categoryId, productId);
    
      if (response.status) {
        toast.success("Banner Added!");
        setIsModalOpen(false);
        getBanners();
      } else {
        toast.error("Error saving banner!");
      }
    };
    
  
  return (
    <Layout>
      <ToastContainer />
      <section className="banner-page" aria-label="Banner management">
        <header className="banner-header">
          <div><p className="banner-eyebrow">CONTENT MANAGEMENT</p><h1>Banners</h1><p>Manage the promotional images shown across your storefront.</p></div>
          <div className="banner-header-actions"><span>{banners.length} {banners.length === 1 ? "banner" : "banners"}</span><button className="banner-add" onClick={() => setIsModalOpen(true)}><PlusIcon />Add banner</button></div>
        </header>

        <section className="banner-card" aria-label="Banner preview">
          <div className="banner-card-heading"><div><h2>Live preview</h2><p>Swipe through your active promotional banners.</p></div>{banners.length > 0 && <button className="banner-delete" onClick={handleDelete}><TrashIcon />Delete current</button>}</div>
          {banners.length ? <Swiper className="banner-swiper" spaceBetween={20} slidesPerView={1} loop={banners.length > 1} autoplay={{ delay: 3000 }} onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}>
            {banners.map((banner) => <SwiperSlide key={banner.bannerId}><div className="banner-slide"><img src={banner.image} alt="Promotional banner" /><div className="banner-slide-meta"><span>Priority</span><strong>{banner.priority}</strong></div></div></SwiperSlide>)}
          </Swiper> : <div className="banner-empty"><div className="banner-empty-icon"><ArrowUpTrayIcon /></div><h3>No banners yet</h3><p>Add a promotional image to see it here.</p><button className="banner-add" onClick={() => setIsModalOpen(true)}><PlusIcon />Add your first banner</button></div>}
          {banners.length > 1 && <div className="banner-counter">{activeIndex + 1} / {banners.length}</div>}
        </section>

          {isModalOpen && (
            <div className="banner-modal-backdrop fixed inset-0 flex items-center justify-center" role="dialog" aria-modal="true" aria-label="Add new banner">
              <div className="banner-modal">
                <div className="banner-modal-heading"><div><p className="banner-eyebrow">NEW CONTENT</p><h2>Add new banner</h2></div><button aria-label="Close" onClick={() => setIsModalOpen(false)}>×</button></div>

                {/* Image Upload */}
                <label className="banner-field-label">Upload image</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  className="banner-file-input"
                />

                <div className="mb-4">
                  <label className="banner-field-label">Priority number</label>
                  <input
                    type="number"
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                    className="banner-input"
                  />
                </div>

                {/* Restaurant Dropdown */}
                <label className="banner-field-label">Restaurant <span>(optional)</span></label>
                <select onChange={handleRestaurantChange} className="banner-input">
                  <option value="">Choose a Restaurant</option>
                  {restaurants.map((r) => (
                    <option key={r.restaurant_id} value={r.restaurant_id}>
                      {r.name}
                    </option>
                  ))}
                </select>



                {/* Category Dropdown */}
                {selectedRestaurant && (
                  <>
                    <label className="banner-field-label">Category <span>(optional)</span></label>
                    <select onChange={handleCategoryChange} className="banner-input">
                      <option value="">Choose a Category</option>
                      {selectedRestaurant.menuCategory.map((c) => (
                        <option key={c.menuCatId} value={c.menuCatId}>
                          {c.name}
                        </option>
                      ))}
                    </select>
                  </>
                )}

                {/* Product Dropdown */}
                {selectedCategory && (
                  <>
                    <label className="banner-field-label">Product <span>(optional)</span></label>
                    <select onChange={handleProductChange} className="banner-input">
                      <option value="">Choose a Product</option>
                      {selectedCategory.products.map((p) => (
                        <option key={p.productId} value={p.productId}>
                          {p.name}
                        </option>
                      ))}
                    </select>
                  </>
                )}

                <div className="banner-modal-actions">
                  <button
                    className="banner-cancel"
                    onClick={() => setIsModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="banner-save"
                    onClick={handleSave}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          )}
      </section>
    </Layout>
  );
};

export default Banners;
